/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgWalletWithdraw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} y={0.5} fill="currentColor" rx={20} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M15 19.975V29.5h10V17.018h2.692a1 1 0 1 0 0-2H12.308a1 1 0 1 0 0 2H15v2.958ZM27 20h3a1 1 0 0 0 1-1v-8.5a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v8.473a1 1 0 0 0 1 1h3V30.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V20Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="m17.851 25.416.645-.902c.317.25.612.433.883.545.27.106.575.155.912.149.331-.007.596-.073.794-.198a.614.614 0 0 0 .298-.536.554.554 0 0 0-.14-.377 1.4 1.4 0 0 0-.337-.278 2.103 2.103 0 0 0-.406-.198c-.146-.053-.268-.1-.367-.14a18.83 18.83 0 0 1-.754-.287 2.846 2.846 0 0 1-.655-.367 1.968 1.968 0 0 1-.456-.536c-.113-.211-.169-.473-.169-.783 0-.185.036-.37.11-.556a1.72 1.72 0 0 1 .317-.526c.145-.158.324-.294.535-.406.219-.113.47-.189.754-.229v-.535h.695v.516c.218.02.416.056.595.109.185.046.35.106.496.178.152.066.284.136.397.209.119.072.218.142.297.208l-.615.873a1.36 1.36 0 0 0-.268-.159 3.063 3.063 0 0 0-.357-.149 2.441 2.441 0 0 0-.407-.128 1.75 1.75 0 0 0-.406-.05 1.441 1.441 0 0 0-.466.05.998.998 0 0 0-.328.138.758.758 0 0 0-.188.199.47.47 0 0 0-.06.228c0 .112.027.212.08.297.06.087.135.163.228.229.099.066.208.125.327.178.126.047.255.096.387.15l.129.049c.245.092.493.198.744.317.258.12.493.261.704.427.212.165.384.363.516.595.139.225.208.493.208.803 0 .232-.046.453-.139.665-.092.212-.224.4-.396.566a2.326 2.326 0 0 1-.635.406 2.585 2.585 0 0 1-.843.189v.674h-.695v-.694a3.46 3.46 0 0 1-1.071-.298 3.982 3.982 0 0 1-.893-.615Z"
    />
  </svg>
)
const Memo = memo(SvgWalletWithdraw)
export default Memo
